import { POP_SESSION, POP_PROFILE, PHP_SESSION, IS_PRODUCTION, RT } from '@constants';
import * as actions from '@store/actions';
import { Global } from '@modules/global';
import { redirect, Cookie } from '@libs';
import { DEFAULT_LOCALE, PRIMARY_LANG } from '@constants/langs';

let instance = null;

class Auth {
  constructor() {
    if (!instance) {
      instance = this;
    }

    return instance;
  }

  setAuthData({ access_token, expires_in, refresh_token, id }, { ctx }) {
    if (!access_token || !refresh_token || !expires_in) {
      throw new Error('Invalid token data');
    }

    const expireRatio = 0.9; // из-за разницы с серверным временем, считаем что токен закончится раньше
    const expire = Math.floor(Date.now() / 1000 + expires_in * expireRatio);
    const secure = IS_PRODUCTION;
    const value = JSON.stringify({ access_token, expire, refresh_token, id });
    const maxAge = 14 * 86400;
    const path = '/';

    Cookie.set(ctx, POP_SESSION, value, { maxAge, secure, path });
    Cookie.remove(ctx, RT);
  }

  setUser() {
    const { dispatch } = Global.store;

    dispatch(actions.setUser());
  }

  getAuthData({ ctx }) {
    return Cookie.getJSON(ctx, POP_SESSION);
  }

  getAuthRt({ ctx }) {
    return  Cookie.get(ctx, RT);
  }

  logout({ locale = PRIMARY_LANG.value, ctx = null }) {
    // Если есть ctx значит мы на сервере и берем dispatch с ctx
    const store = ctx ? ctx.store : null;
    const dispatch = ctx ? store.dispatch : Global.store.dispatch;

    Cookie.remove(ctx, POP_PROFILE);
    Cookie.remove(ctx, POP_SESSION);
    Cookie.remove(ctx, PHP_SESSION);
    dispatch(actions.removeUser());
    redirect('/', {
      locale: locale === PRIMARY_LANG.value ? DEFAULT_LOCALE : locale,
    });
  }
}

export const auth = new Auth();
